module.exports = __webpack_public_path__ + "img/prd icon@2x.3d9d6d7d.png";